import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';
import { HabitatListItem } from '@/queries/habitats/types';

import HabitatGridItem from './HabitatGridItem';

interface HabitatsGridProps extends ComponentProps<'div'> {
  habitats: HabitatListItem[];
}

const HabitatsGrid = ({ habitats, className, ...props }: HabitatsGridProps) => {
  return (
    <div
      className={cn('grid grid-cols-2 gap-2 md:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] md:gap-4', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {habitats.map((habitat) => (
        <HabitatGridItem key={habitat._id} habitat={habitat} />
      ))}
    </div>
  );
};

export default HabitatsGrid;
